import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { flatMap, shuffle } from 'lodash';
export const extractClosetPromoBanner = (banners, screen) => banners === null || banners === void 0 ? void 0 : banners.closetPromotionBanners.find(banner => banner.name === screen);
export const getRandomizedListerActivationBanner = banners => {
  const totalBanners = banners.length;
  const targetBannerIndex = Math.floor(Math.random() * totalBanners);
  const targetBanner = banners[targetBannerIndex];
  return _objectSpread(_objectSpread({}, targetBanner), {}, {
    imageUrls: shuffle(targetBanner.imageUrls)
  });
};
export const findListerActivationBannerFromCatalogIds = (catalogIds, banners) => {
  const bannerCatalogIds = banners.map(_ref => {
    let {
      catalogId
    } = _ref;
    return catalogId;
  });
  const targetCatalogId = catalogIds.find(id => bannerCatalogIds.find(catalogId => catalogId === id));
  if (!targetCatalogId) return undefined;
  return banners.find(_ref2 => {
    let {
      catalogId
    } = _ref2;
    return catalogId === targetCatalogId;
  });
};
export const getParentListerActivationBanner = (catalogs, catalogMap, banners) => {
  const catalogIdsWithParents = flatMap(catalogs, catalog => {
    const catalogParentIds = [];
    let targetCatalog = catalog;

    while (targetCatalog) {
      catalogParentIds.push(targetCatalog.id);
      targetCatalog = catalogMap[targetCatalog.parentId];
    }

    return catalogParentIds;
  });
  const targetBanner = findListerActivationBannerFromCatalogIds(catalogIdsWithParents, banners);
  return targetBanner ? [targetBanner] : undefined;
};
export const getRootCatalogListerActivationBanners = (catalogs, banners) => {
  const rootCatalogs = catalogs.filter(_ref3 => {
    let {
      depth
    } = _ref3;
    return depth === 0;
  });

  for (let index = 0; rootCatalogs[index]; index += 1) {
    const childrenIds = rootCatalogs[index].catalogIds;
    const rootBanners = banners.filter(_ref4 => {
      let {
        catalogId
      } = _ref4;
      return childrenIds.includes(catalogId);
    });
    if (rootBanners.length) return rootBanners;
  }

  return undefined;
};